import React, { PropTypes } from "react";
import userHasAccess from "../../utils/userHasAccess";
import _ from "lodash";

function hasAccess(props) {
  if (String(props.for).toUpperCase() === "ALL") {
    return props.if;
  }
  if (userHasAccess(props.for, props.only)) {
    return props.if;
  }
  if (userHasAccess(props.exactly, true)) {
    return props.if;
  }
  return false;
}

const Render = (props) => {
  const children = _.isArray(props.children) ? (
    <div>{props.children}</div>
  ) : (
    props.children
  );
  return hasAccess(props) ? children : null;
};

Render.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  exactly: PropTypes.oneOfType([
    PropTypes.shape({
      roleId: PropTypes.number,
    }),
    PropTypes.array,
  ]),
  for: PropTypes.oneOfType([
    PropTypes.shape({
      roleId: PropTypes.number,
    }),
    PropTypes.oneOf(["ALL", "All", "all"]),
    PropTypes.array,
  ]),
  if: PropTypes.bool,
  only: PropTypes.bool,
};

Render.defaultProps = {
  for: "ALL",
  if: true,
  only: false,
};

export default Render;



// WEBPACK FOOTER //
// ./src/components/common/Render.js